var LoadingCheckoutStore = reactive({
  loading: false,
  setLoading: function setLoading(isLoading) {
    this.loading = isLoading;
  }
});
export { LoadingCheckoutStore };